/** A region's zone, as an IANA name Postgres and every browser know. */
export const REGION_TIME_ZONES = {
    US: {
        AL: 'America/Chicago', AK: 'America/Anchorage', AZ: 'America/Phoenix', AR: 'America/Chicago',
        CA: 'America/Los_Angeles', CO: 'America/Denver', CT: 'America/New_York', DE: 'America/New_York',
        DC: 'America/New_York', FL: 'America/New_York', GA: 'America/New_York', HI: 'Pacific/Honolulu',
        ID: 'America/Boise', IL: 'America/Chicago', IN: 'America/New_York', IA: 'America/Chicago',
        KS: 'America/Chicago', KY: 'America/New_York', LA: 'America/Chicago', ME: 'America/New_York',
        MD: 'America/New_York', MA: 'America/New_York', MI: 'America/Detroit', MN: 'America/Chicago',
        MS: 'America/Chicago', MO: 'America/Chicago', MT: 'America/Denver', NE: 'America/Chicago',
        NV: 'America/Los_Angeles', NH: 'America/New_York', NJ: 'America/New_York', NM: 'America/Denver',
        NY: 'America/New_York', NC: 'America/New_York', ND: 'America/Chicago', OH: 'America/New_York',
        OK: 'America/Chicago', OR: 'America/Los_Angeles', PA: 'America/New_York', RI: 'America/New_York',
        SC: 'America/New_York', SD: 'America/Chicago', TN: 'America/Chicago', TX: 'America/Chicago',
        UT: 'America/Denver', VT: 'America/New_York', VA: 'America/New_York', WA: 'America/Los_Angeles',
        WV: 'America/New_York', WI: 'America/Chicago', WY: 'America/Denver',
        AS: 'Pacific/Pago_Pago', GU: 'Pacific/Guam', MP: 'Pacific/Saipan', PR: 'America/Puerto_Rico',
        VI: 'America/St_Thomas',
    },
    CA: {
        AB: 'America/Edmonton', BC: 'America/Vancouver', MB: 'America/Winnipeg', NB: 'America/Moncton',
        NL: 'America/St_Johns', NS: 'America/Halifax', NT: 'America/Edmonton', NU: 'America/Iqaluit',
        ON: 'America/Toronto', PE: 'America/Halifax', QC: 'America/Toronto', SK: 'America/Regina',
        YT: 'America/Whitehorse',
    },
};
/** The zone an address keeps, or null when it names no region this table knows. */
export function zoneForRegion(country, state) {
    if (!state)
        return null;
    const table = REGION_TIME_ZONES[(country ?? 'US').toUpperCase()];
    return table?.[state.toUpperCase()] ?? null;
}
/*
 * What people call a zone. The zones above by the words a dispatcher uses
 * (*Eastern*, not *America/Detroit*); anything else by its city.
 */
const ZONE_WORDS = {
    'America/New_York': 'Eastern', 'America/Detroit': 'Eastern',
    'America/Toronto': 'Eastern', 'America/Iqaluit': 'Eastern',
    'America/Chicago': 'Central', 'America/Winnipeg': 'Central', 'America/Regina': 'Central, no daylight saving',
    'America/Denver': 'Mountain', 'America/Boise': 'Mountain', 'America/Edmonton': 'Mountain',
    'America/Phoenix': 'Mountain, no daylight saving',
    'America/Los_Angeles': 'Pacific', 'America/Vancouver': 'Pacific',
    'America/Anchorage': 'Alaska', 'Pacific/Honolulu': 'Hawaii',
    'America/Halifax': 'Atlantic', 'America/Moncton': 'Atlantic', 'America/Puerto_Rico': 'Atlantic',
    'America/St_Thomas': 'Atlantic', 'America/St_Johns': 'Newfoundland', 'America/Whitehorse': 'Yukon',
    'Pacific/Guam': 'Chamorro', 'Pacific/Saipan': 'Chamorro', 'Pacific/Pago_Pago': 'Samoa',
    UTC: 'UTC',
};
/** *Eastern*, *Mountain, no daylight saving*, or the zone's city (*Europe / London*). */
export function zoneWords(zone) {
    return ZONE_WORDS[zone] ?? zone.replace(/_/g, ' ').replace(/\//g, ' / ');
}
/** *Eastern · America/New_York* — the selector's row, which says the word and the name it stores. */
export function zoneOptionLabel(zone) {
    const words = ZONE_WORDS[zone];
    return words ? `${words} · ${zone.replace(/_/g, ' ')}` : zone.replace(/_/g, ' ').replace(/\//g, ' / ');
}
//# sourceMappingURL=time-zones.js.map